import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import AffiliationPopover from '../AffiliationPopover/AffiliationPopover';
import { faTooth } from '@fortawesome/free-solid-svg-icons';

// Partner or Carrier
const AffiliationItem = (props) => {
    const {
        data: {
            organizationName,
            landingPageUrl,
            logo,
            logoUrl=null,
            contactNumber,
            edeLevel,
            sadpIndicator,
            carrierFlag=false,
            isCarrierFlag
        }
    } = props;

    const logoSrc = logo || logoUrl;
    const isShowEde = (!isCarrierFlag || !carrierFlag) && edeLevel;

    return (
        <li className={'grid-row gi-card_list'}>
            <div className={'desktop:grid-col-4 tablet:grid-col-4 mobile:grid-col-12 gi-card_list_col'}>
                <img src={logoSrc} alt={organizationName}/>
            </div>

            <div className={'desktop:grid-col-4 tablet:grid-col-4 mobile:grid-col-12 gi-card_list_col'}>
                <h3>{organizationName}</h3>
                { isShowEde &&  <AffiliationPopover edeLevel={edeLevel}/> }
                { sadpIndicator &&
                    <div>
                        <FontAwesomeIcon icon={faTooth}/>
                        <FormattedMessage id='gaep.sadp'/>
                    </div>
                }
            </div>

            <div className={'desktop:grid-col-4 tablet:grid-col-4 mobile:grid-col-12 gi-card_list_col'}>
                <div><a href={landingPageUrl}>{landingPageUrl}</a></div>
                <div>{contactNumber}</div>
            </div>
        </li>
    );
};

export default AffiliationItem;